<template>
<div class="chapter">
<div class="inner_page">
<div class="sidebar">
<h2 class="h2"><a id="part01"></a><a id="page_37">PART ONE</a></h2><a id="page_37">
<h2 class="h2title">GATHERING</h2>
<p class="poem1">I am sure you will catch on,</p>
<p class="poem">and go on and on</p>
<p class="poem">and be something and somebody.</p>
</a><p class="att"><a id="page_37">—<span class="small">E. H. HARRIMAN TO HIS SON AVERELL</span></a><a id="page_38"></a></p><a id="page_38">
</a></div><a id="page_38">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01.vue?57716bd6